import React, { useState } from 'react';
import { Badge } from './ui/Badge';
const QUICK_QUESTIONS = [{
  id: 'q1',
  label: 'Trans-inclusive healthcare?'
}, {
  id: 'q2',
  label: 'No recent layoffs?'
}, {
  id: 'q3',
  label: 'Diverse leadership?'
}, {
  id: 'q4',
  label: 'Remote-friendly?'
}, {
  id: 'q5',
  label: '16+ weeks parental leave?'
}];
export function QuickQuestions() {
  const [activeIds, setActiveIds] = useState<Set<string>>(new Set());
  const toggleQuestion = (id: string) => {
    const newActive = new Set(activeIds);
    if (newActive.has(id)) {
      newActive.delete(id);
    } else {
      newActive.add(id);
    }
    setActiveIds(newActive);
  };
  return <div className="flex items-center gap-3 px-6 py-2 border-b border-border/50 bg-muted/20 overflow-x-auto no-scrollbar" data-id="element-151">
      <span className="text-[11px] font-mono text-muted-foreground uppercase tracking-wider whitespace-nowrap" data-id="element-152">
        Quick Filters:
      </span>
      <div className="flex gap-2" data-id="element-153">
        {QUICK_QUESTIONS.map(q => {
        const isActive = activeIds.has(q.id);
        return <Badge key={q.id} variant={isActive ? 'default' : 'outline'} className={`cursor-pointer font-mono text-[11px] h-6 px-2.5 rounded-sm transition-colors whitespace-nowrap ${isActive ? 'bg-primary text-primary-foreground hover:bg-primary/90' : 'bg-background hover:bg-muted text-muted-foreground hover:text-foreground border-border/60'}`} onClick={() => toggleQuestion(q.id)} data-id="element-154">
              {q.label}
            </Badge>;
      })}
      </div>
    </div>;
}